import {Dispatch, SetStateAction} from 'react'
import cn from 'clsx'
import {Upload, Avatar} from 'antd'
import {UploadFile} from 'antd/es/upload/interface'
import ImgCrop from 'antd-img-crop'

import './UserPhoto.scss'
import {useUploadFile} from 'common/api'
import {Box, Loader, ProfileCircleIcon} from 'common/components'
import {FileInterface} from 'common/types'

interface UserPhotoProps {
  medium?: boolean
  large?: boolean
  image: FileInterface
  setImage: Dispatch<SetStateAction<FileInterface>>
}

export default function UserPhoto({medium, large, image, setImage}: UserPhotoProps) {
  const {mutate: uploadFile, isLoading} = useUploadFile({
    setFile: (image: FileInterface) => setImage(image),
  })

  const handleDownload = ({file}: any) => uploadFile(file)

  const onPreview = async (file: UploadFile) => {
    let src = file.url
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file.originFileObj)
        reader.onload = () => resolve(reader.result as string)
      })
    }
    const img = new Image()
    img.src = src
    const imgWindow = window.open(src)
    imgWindow?.document.write(img.outerHTML)
  }

  return (
    <div className={cn(
      'UserPhoto', 
      !!large ? 'UserPhoto_large' :
      !!medium ? 'UserPhoto_medium' :
      ''
    )}>
      <div className="UserPhoto-Wrapper">
        <ImgCrop rotate>
          <Upload
            accept=".jpg,.jpeg,.png"
            name="avatar"
            listType="picture-card"
            showUploadList={false}
            disabled={isLoading}
            onPreview={onPreview}
            customRequest={handleDownload}
          >
            <Loader
              className="UserPhoto-Loader"
              show={isLoading}
              type="block"
            />
            {image.url ? (
              <Avatar size={120} src={image.url} alt="User's photo" />
            ) : (
              <Box color="grey">
                <ProfileCircleIcon />
                <p>Photo</p>
              </Box>
            )}
          </Upload>
        </ImgCrop>
      </div>
    </div>
  )
}
